export enum DateValidationReason {
  InvalidFormat = 'InvalidFormat',
  DatesInPast = 'DatesInPast',
  TooFarInFuture = 'TooFarInFuture',
  StayTooLong = 'StayTooLong'
}
